import React from 'react';

const InlineAlert = ({
  variant = 'danger',
  icon = 'exclamation-circle',
  title,
  message,
  className = '',
  live = 'polite',
  ariaLabel,
  dataTestId,
  onDismiss,
  children
}) => {
  const classes = `alert alert-${variant} ${className}`.trim();

  return (
    <div className={classes} role="alert" aria-live={live} aria-label={ariaLabel} data-testid={dataTestId}>
      <div className={onDismiss ? 'd-flex justify-content-between align-items-start' : undefined}>
        <div>
          {icon && <i className={`bi bi-${icon} me-2`}></i>}
          {title && <strong>{title}</strong>}
          {title && message ? ' ' : null}
          {message}
          {children}
        </div>
        {onDismiss && (
          <button
            className={`btn btn-sm btn-link text-${variant} p-0`}
            type="button"
            onClick={onDismiss}
            title="Close alert"
            aria-label="Close alert"
          >
            <i className="bi bi-x"></i>
          </button>
        )}
      </div>
    </div>
  );
};

export default InlineAlert;
